import React from 'react';
import { Input, InputProps } from '../../atoms/Input';

import { IconWrapper, SearchAction, Wrapper } from './styles';

export const SearchInput = ({ ...props }: SearchInputProps) => {
  return (
    <Input
      {...props}
      postfix={
        <IconWrapper>
          <Wrapper>
            <SearchAction />
          </Wrapper>
        </IconWrapper>
      }
    />
  );
};

export type SearchInputProps = InputProps;
